module.exports = __webpack_public_path__ + "fonts/euclid-square-600-italic.09078ce6.ttf";